import React from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function SubmitDialog({
  open,
  submitting,
  questions,
  marks,
  total,
  maxTotal,
  unviewedPages,
  onClose,
  onConfirm,
  onJumpQuestion,
  onJumpPage,
}) {
  const unmarked = questions.filter(
    (question) =>
      marks[question.key] === null || marks[question.key] === undefined,
  );

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      onClose={submitting ? undefined : onClose}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Submit final marks?</DialogTitle>
      <DialogContent dividers>
        <Box textAlign="center" py={1}>
          <Typography variant="h4" fontWeight={800}>
            {total}
            <Typography component="span" variant="h6" color="text.secondary">
              {" "}
              / {maxTotal}
            </Typography>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {questions.length - unmarked.length} of {questions.length} questions
            marked
          </Typography>
        </Box>

        {unmarked.length > 0 && (
          <Alert severity="warning" sx={{ mt: 1.5 }}>
            <Typography variant="body2" fontWeight={600} gutterBottom>
              Questions without marks
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={0.5}>
              {unmarked.map((question) => (
                <Chip
                  key={question.key}
                  size="small"
                  label={`Q${question.no}`}
                  onClick={() => onJumpQuestion(question.key)}
                />
              ))}
            </Box>
          </Alert>
        )}

        {unviewedPages.length > 0 && (
          <Alert severity="info" sx={{ mt: 1.5 }}>
            <Typography variant="body2" fontWeight={600} gutterBottom>
              Pages not opened yet
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={0.5}>
              {unviewedPages.map((page) => (
                <Chip
                  key={page}
                  size="small"
                  label={`p${page}`}
                  onClick={() => onJumpPage(page)}
                />
              ))}
            </Box>
          </Alert>
        )}

        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          sx={{ mt: 1.5 }}
        >
          This script will lock after you submit.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={submitting} onClick={onClose}>
          Keep marking
        </Button>
        <Button variant="contained" disabled={submitting} onClick={onConfirm}>
          {submitting ? "Submitting…" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
